import Component from '../abstracts/Component';
import {doAjax} from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';

export default class AddToCartComponent extends Component {

  get COMPONENTNAME() {
    return 'AddToCartComponent';
  }

  get SELECTORS() {
    return {
      addToCartBtn: '[data-addtocart]',
      main: '.js-addtocart',
      error: '.js-addtocart-notification',
      giftcardForm: '[data-giftcard-form] form',
      giftcardBtn: '[data-submit="addtocart-giftcard"]',
      giftcardPrivacy: 'input[name=gcTerms]',
      giftcardAddedAmount: 'input[name=giftcardAddedAmount]',
      miniCart: '.js-minicart',
      quickCart: '.l-quick-cart',
      quickCartWrapper: '.c-m-h__actions__desk-mini-cart.action--quickcart',
    }
  }

  get CLASSES() {
    return {
      selected: 'selected',
      unavailable: 'unavailable',
      visible: 'show',
      hideQty: 'hideQty',
      loadingClass: 'loading',
    }
  }

  get FORM_RESULT_STATUSES() {
    return {
      ok: 'OK',
      error: 'error',
    }
  }

  constructor() {
    super();
    this.addToCartBtns = document.querySelectorAll(this.SELECTORS.addToCartBtn);
    this.mainTarget = document.querySelector(this.SELECTORS.main);
    this.timeout = null;
    this.error = $(this.SELECTORS.error);
    this.giftcardForm = document.querySelector(this.SELECTORS.giftcardForm);
    this.giftcardBtn = document.querySelector(this.SELECTORS.giftcardBtn);
    this.giftcardPrivacy = document.querySelector(this.SELECTORS.giftcardPrivacy);
    this.updateMiniCartBtn = $(this.SELECTORS.miniCart);
    this.quickCart = $(this.SELECTORS.quickCart);
    this.quickCartWrapper = $(this.SELECTORS.quickCartWrapper);
    this.TrackingComponent = new TrackingComponent();
  }

  openMinicart(elem) {
    // vars
    const isGiftcard = elem === 'giftcard';
    let self = this;
    let productCode;
    let button;
    // check if card i need another layer
    if(isGiftcard) {
      return this.openMinicartGiftcard();
    }
    // get info
    button = elem || this.mainTarget;
    // check unique size
    if(button.dataset.uniqueSize === 'true') {
      productCode = button.dataset.productCode;
    } else {
      productCode = this.selectedSize(button);
    }
    // button for url
    let mincartBtn = document.querySelector(this.SELECTORS.miniCart);
    // launch ajax minicart
    return doAjax({
      url: mincartBtn.dataset.link,
      data: {
        'productCode': productCode
      },
      dataType: 'html',
      type: 'POST',
      success: function(resp) {
        self.openMinicartSuccess(resp);
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  openMinicartGiftcard() {
    let self = this;
    let $elem = self.updateMiniCartBtn;

    return doAjax({
      url: $elem.data('giftcard-link'),
      dataType: 'html',
      success: function(resp) {
        self.openMinicartSuccess(resp);
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  // TOIMPROVE
  openMinicartSuccess(resp) {
    let self = this;
    let $replace = self.quickCart;
    self.log('Open Minicart...');
    let response = new DOMParser().parseFromString(resp, 'text/html');
    $(response).find('.icon-close').remove();
    $(response).find('.l-q-c__checkout__detail').remove();
    $(response).find('.l-q-c__checkout__note').remove();
    $(response).find('.l-q-c__checkout').css('background-color', '#FFFFFF');
    $replace.html(response.querySelector('.l-quick-cart').innerHTML);
    $replace.removeClass('empty');
    clearTimeout(this.timeout);
    self.quickCart.find('.l-q-c__title').attr('data-mcqty', '');
    self.quickCart.find('.l-q-c__title').addClass(self.CLASSES.hideQty);
    self.quickCartWrapper.addClass(self.CLASSES.visible);
    setTimeout(() => {
      self.quickCartWrapper.removeClass(self.CLASSES.visible);
      self.updateMinicart();
    }, 2000);
  }



  cleaningSelectedSize(elem) {
    // get product code to target sizes box
    let productCode = elem.dataset.productCode;
    let sizesWrapper = document.querySelector('[data-sizes=prod-'+productCode+']');
    // reset size
    if(sizesWrapper !== null) {
      let selectedSize = sizesWrapper.querySelector('.' + this.CLASSES.selected);
      if(selectedSize != null) selectedSize.classList.remove(this.CLASSES.selected);
    }
  }

  updateMinicart() {
    let self = this;
    let $elem = self.updateMiniCartBtn;
    let $replace = self.quickCart;

    return doAjax({
      url: $elem.data('url'),
      dataType: 'html',
      success: function(resp) {
        self.log('Minicart updated...');
        let response = new DOMParser().parseFromString(resp, 'text/html');
        $replace.html(response.querySelector('.l-quick-cart').innerHTML);
        $replace.removeClass('empty');
        // update cart counter
        self.updateQty();
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  updateQty() {
    let qty = this.quickCart.find('.l-q-c__title').data('mcqty');
    if(this.updateMiniCartBtn != null) {
      this.updateMiniCartBtn.find('.icon-box__dot').attr('data-mcqty', qty);
    }
    if(qty > 0) {
	  this.updateMiniCartBtn.find('.icon-box__dot').removeClass('hidden');
    } else {
      this.updateMiniCartBtn.find('.icon-box__dot').addClass('hidden');
    }
  }

  selectedSize(btn) {
    // get product code
    let productCode = btn.dataset.productCode;
    // get size div
    let sizesBox = document.querySelector('[data-sizes="prod-' + productCode + '"]');
    // check
    if(sizesBox == null) return false;
    // find selected size
    let sizeSelected = sizesBox.querySelector('.' + this.CLASSES.selected);
    // if not null
    if(sizeSelected != null) {
      // check if
      return sizeSelected.classList.contains(this.CLASSES.unavailable) ? this.CLASSES.unavailable : sizeSelected.dataset.productCode;
    } else {
      return false;
    }
  }

  productAddToCart() {
    // global
    let self = this;
    // check
    if(this.addToCartBtns === null) return;
    // click on addtocart
    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.addEventListener('click', e => {
        e.preventDefault();
        // btn
        let btn = e.currentTarget;
        // check if is unique size
        if(btn.dataset.uniqueSize === 'true') {
          // go add to cart
          self.$emit(self.$customEvents.PRODUCT_EVENTS.addtocart, {button: e.currentTarget, sizeCode: btn.dataset.productCode});
          self.TrackingComponent.actions.addToCart(btn.dataset.productCode);
        } else {
          // check size
          let size =  self.selectedSize(btn);
          // check size selection
          if(size === false) {
            // size false -> trigger size required
            self.$emit(self.$customEvents.PRODUCT_EVENTS.sizerequired, btn);
          } else if(size === 'unavailable') {
            // size unavailable
          } else {
            // go add to cart
            self.$emit(self.$customEvents.PRODUCT_EVENTS.addtocart, {button: btn, sizeCode: size });
            self.TrackingComponent.actions.addToCart(size);
          }
        }
      });
    });
  }

  productAddingToCart(payload) {
    // global
    let self = this;
    // vars
    let elem = payload.button;
    // set the size code into the button
    elem.setAttribute('data-code',payload.sizeCode);
    // disable button
    elem.disabled = true;
    // ajax call
    doAjax({
      url: elem.getAttribute('data-href'),
      data: elem.dataset,
      dataType: 'html',
      success: function(response) {
        // exceed cart quantity
        if(response == 650) {
          console.info('[AddToCart] Exceed cart products');
          let remoteHref = elem.getAttribute('data-exceeded-cart-qty');
          let productCode = elem.getAttribute('data-code');
          let baseCode = elem.getAttribute('data-base-code');
          if(!isNaN(productCode)) {
            remoteHref = remoteHref + productCode;
          } else if(!isNaN(baseCode)) {
            remoteHref = remoteHref + baseCode;
          } else {
            remoteHref = remoteHref + elem.getAttribute('data-product-code');
          }
          doAjax({
            url: remoteHref,
            dataType: 'html',
            success: function(html) {
              elem.disabled = false;
              self.$emit(self.$customEvents.MODAL_EVENTS.show, {unsafeContent: html, modalClass: 'exceeded-cart-products', size: payload.sizeCode});
              console.info('[AddToCart] Exceed product max number on cart.');
            },
            error: function(xhr) {
              elem.disabled = false;
              console.error('[AddToCart]', xhr, arguments);
            }
          });
        } else {
          // success
          elem.disabled = false;
          // cart actions
          self.openMinicart(elem);
          self.cleaningSelectedSize(elem);
        }
        // hide loader event
        self.$emit(self.$customEvents.LOADER_EVENTS.hideLocal, {button: elem});
        // hide the menu
        self.$emit(self.$customEvents.MENU_EVENTS.hideMenu, {time: 3000}, '.action--quickcart');
      },
      error: function(xhr) {
        // hide loader event
        self.$emit(self.$customEvents.LOADER_EVENTS.hideLocal, {button: elem});
        // on error i check the status
        if(xhr.status === 510) {
          // url for availability
          var remoteHref = elem.dataset.remoteUnavailable + elem.dataset.code;
          // ajax call
          doAjax({
            url: remoteHref,
            dataType: 'html',
            success: function(html) {
              elem.disabled = false;
              self.$emit(self.$customEvents.MODAL_EVENTS.show, {unsafeContent: html, modalClass: 'unavailable-product', type: 'product-unavailable'});
            },
            error: function(xhr) {
              elem.disabled = false;
              self.error.html('Error in addtocart');
              console.error('[AddToCart] 510', xhr, arguments);
            }
          });
        } else {
          elem.disabled = false;
          self.error.html('Error in addtocart');
          console.error('[AddToCart]', xhr, arguments);
        }
      }
    });

  }

  /* GIFT CARD PART */
  checkGcTerms(reload = false) {
    // privacy checkbox
    let gcPrivacy = this.giftcardPrivacy;
    if(reload) {
      gcPrivacy = document.querySelector(this.SELECTORS.giftcardPrivacy);
      gcPrivacy.checked = false;
    }
    let gcBtn = this.giftcardPrivacy;
    if(reload) gcBtn = document.querySelector(this.SELECTORS.giftcardBtn);
    console.log(this.giftcardBtn);
    if(gcPrivacy !== null) gcBtn.disabled = !gcPrivacy.checked === true;
  }

  giftCardAddToCart(reload = false) {
    // global
    let self = this;
    // vars
    let gcBtn = this.giftcardBtn;
    if(reload) gcBtn = document.querySelector(this.SELECTORS.giftcardBtn);
    // check
    if(gcBtn == null ) return;
    // click on addtocart
    gcBtn.addEventListener('click', e => {
      e.preventDefault();
      // vars
      let elem = gcBtn;
      let $form = (reload) ? $(this.SELECTORS.giftcardForm) : $(this.giftcardForm);
      // disable button
      elem.disabled = true;
      // form loading
      $form.addClass(self.CLASSES.loadingClass);
      // go ajax
      doAjax({
        type: 'post',
        url: $form.attr('action'),
        data: $form.serialize(),
        contentType: 'application/x-www-form-urlencoded',
        success: function(responseData, textStatus, jqXHR) {
          // replace all form html
          self.giftcardForm.innerHTML = responseData;
          // emit events
          self.$emit(self.$customEvents.PRODUCT_EVENTS.giftcardaddtocart);
          // check if there are errors and show minicart notification
          let formResultStatus = self.getFormResultStatus(responseData);
          if(self.FORM_RESULT_STATUSES.ok === formResultStatus) {
            // if it's a go
            self.openMinicart('giftcard');
            let giftcardAddedAmount = document.querySelector(self.SELECTORS.giftcardAddedAmount);
            if(giftcardAddedAmount != null && giftcardAddedAmount.value != null) {
              self.TrackingComponent.actions.addCartGiftCard(giftcardAddedAmount.value);
            }
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // enable button
          elem.disabled = false;
        }
      })

    });
  }

  getFormResultStatus(htmlForm) {
    let match = htmlForm.match("data-result=\"(" + this.FORM_RESULT_STATUSES.ok + "|" + this.FORM_RESULT_STATUSES.error + ")\"");
    return match[1];
  }

  bindEvents() {
    // global
    let self = this;

    // Add To Cart
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {
      // adding to cart
      self.productAddingToCart(payload);
    });

    // GC add to cart
    this.$on(this.$customEvents.PRODUCT_EVENTS.giftcardaddtocart, ({event, payload}) => {
      // rebind button
      self.giftCardAddToCart(true);
      // reset privacy
      self.checkGcTerms(true);
      // reset loading class
      let form = document.querySelector(this.SELECTORS.giftcardForm);
      if(form !== null) form.classList.remove(self.CLASSES.loadingClass);
    });

  }

  render() {
    this.log('Rendering...');
    // Bind the events
    this.bindEvents();
    // product add to cart
    this.productAddToCart();
    // giftcard add to cart
    this.giftCardAddToCart();
  }
}
